import _classCallCheck from "/opt/build/repo/docs/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/docs/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/opt/build/repo/docs/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/opt/build/repo/docs/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/opt/build/repo/docs/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { ContextualKeyword } from "../parser/tokenizer/keywords";
import { TokenType as tt } from "../parser/tokenizer/types";
import elideImportEquals from "../util/elideImportEquals";
import getDeclarationInfo, { EMPTY_DECLARATION_INFO } from "../util/getDeclarationInfo";
import { getNonTypeIdentifiers } from "../util/getNonTypeIdentifiers";
import shouldElideDefaultExport from "../util/shouldElideDefaultExport";
import Transformer from "./Transformer";

/**
 * Class for editing import statements when we are keeping the code as ESM. We still need to remove
 * type-only imports in TypeScript and Flow.
 */
var ESMImportTransformer = /*#__PURE__*/function (_Transformer) {
  _inherits(ESMImportTransformer, _Transformer);
  var _super = _createSuper(ESMImportTransformer);
  function ESMImportTransformer(tokens, nameManager, reactHotLoaderTransformer, isTypeScriptTransformEnabled, options) {
    var _this;
    _classCallCheck(this, ESMImportTransformer);
    _this = _super.call(this);
    _this.tokens = tokens;
    _this.nameManager = nameManager;
    _this.reactHotLoaderTransformer = reactHotLoaderTransformer;
    _this.isTypeScriptTransformEnabled = isTypeScriptTransformEnabled;
    ;
    _this.nonTypeIdentifiers = isTypeScriptTransformEnabled ? getNonTypeIdentifiers(tokens, options) : new Set();
    _this.declarationInfo = isTypeScriptTransformEnabled ? getDeclarationInfo(tokens) : EMPTY_DECLARATION_INFO;
    return _this;
  }
  _createClass(ESMImportTransformer, [{
    key: "process",
    value: function process() {
      // TypeScript `import foo = require('foo');` should always just be translated to plain require.
      if (this.tokens.matches3(tt._import, tt.name, tt.eq)) {
        return this.processImportEquals();
      }
      if (this.tokens.matches4(tt._import, tt.name, tt.name, tt.eq) && this.tokens.matchesContextualAtIndex(this.tokens.currentIndex() + 1, ContextualKeyword._type)) {
        // import type T = require('T')
        this.tokens.removeInitialToken();
        // This construct is always exactly 8 tokens long, so remove the 7 remaining tokens.
        for (var i = 0; i < 7; i++) {
          this.tokens.removeToken();
        }
        return true;
      }
      if (this.tokens.matches2(tt._export, tt.eq)) {
        this.tokens.replaceToken("module.exports");
        return true;
      }
      if (this.tokens.matches5(tt._export, tt._import, tt.name, tt.name, tt.eq) && this.tokens.matchesContextualAtIndex(this.tokens.currentIndex() + 2, ContextualKeyword._type)) {
        // export import type T = require('T')
        this.tokens.removeInitialToken();
        // This construct is always exactly 9 tokens long, so remove the 8 remaining tokens.
        for (var _i = 0; _i < 8; _i++) {
          this.tokens.removeToken();
        }
        return true;
      }
      if (this.tokens.matches1(tt._import)) {
        return this.processImport();
      }
      if (this.tokens.matches2(tt._export, tt._default)) {
        return this.processExportDefault();
      }
      if (this.tokens.matches2(tt._export, tt.braceL)) {
        return this.processNamedExports();
      }
      if (this.tokens.matches3(tt._export, tt.name, tt.braceL) && this.tokens.matchesContextualAtIndex(this.tokens.currentIndex() + 1, ContextualKeyword._type)) {
        // TS `export type {` case: just remove the export entirely.
        this.tokens.removeInitialToken();
        while (!this.tokens.matches1(tt.braceR)) {
          this.tokens.removeToken();
        }
        this.tokens.removeToken();

        // Remove type re-export `... } from './T'`
        if (this.tokens.matchesContextual(ContextualKeyword._from) && this.tokens.matches1AtIndex(this.tokens.currentIndex() + 1, tt.string)) {
          this.tokens.removeToken();
          this.tokens.removeToken();
        }
        return true;
      }
      return false;
    }
  }, {
    key: "processImportEquals",
    value: function processImportEquals() {
      var importName = this.tokens.identifierNameAtIndex(this.tokens.currentIndex() + 1);
      if (this.isTypeName(importName)) {
        // If this name is only used as a type, elide the whole import.
        elideImportEquals(this.tokens);
      } else {
        // Otherwise, switch `import` to `const`.
        this.tokens.replaceToken("const");
      }
      return true;
    }
  }, {
    key: "processImport",
    value: function processImport() {
      if (this.tokens.matches2(tt._import, tt.parenL)) {
        // Dynamic imports don't need to be transformed.
        return false;
      }
      var snapshot = this.tokens.snapshot();
      var allImportsRemoved = this.removeImportTypeBindings();
      if (allImportsRemoved) {
        this.tokens.restoreToSnapshot(snapshot);
        while (!this.tokens.matches1(tt.string)) {
          this.tokens.removeToken();
        }
        this.tokens.removeToken();
        if (this.tokens.matches1(tt.semi)) {
          this.tokens.removeToken();
        }
      }
      return true;
    }

    /**
     * Remove type bindings from this import, leaving the rest of the import intact.
     *
     * Return true if this import was ONLY types, and thus is eligible for removal. This will bail out
     * of the replacement operation, so we can return early here.
     */
  }, {
    key: "removeImportTypeBindings",
    value: function removeImportTypeBindings() {
      this.tokens.copyExpectedToken(tt._import);
      if (this.tokens.matchesContextual(ContextualKeyword._type) && !this.tokens.matches1AtIndex(this.tokens.currentIndex() + 1, tt.comma) && !this.tokens.matchesContextualAtIndex(this.tokens.currentIndex() + 1, ContextualKeyword._from)) {
        // This is an "import type" statement, so exit early.
        return true;
      }
      if (this.tokens.matches1(tt.string)) {
        // This is a bare import, so we should proceed with the import.
        this.tokens.copyToken();
        return false;
      }
      var foundNonTypeImport = false;
      if (this.tokens.matches1(tt.name)) {
        if (this.isTypeName(this.tokens.identifierName())) {
          this.tokens.removeToken();
          if (this.tokens.matches1(tt.comma)) {
            this.tokens.removeToken();
          }
        } else {
          foundNonTypeImport = true;
          this.tokens.copyToken();
          if (this.tokens.matches1(tt.comma)) {
            this.tokens.copyToken();
          }
        }
      }
      if (this.tokens.matches1(tt.star)) {
        if (this.isTypeName(this.tokens.identifierNameAtIndex(this.tokens.currentIndex() + 2))) {
          this.tokens.removeToken();
          this.tokens.removeToken();
          this.tokens.removeToken();
        } else {
          foundNonTypeImport = true;
          this.tokens.copyExpectedToken(tt.star);
          this.tokens.copyExpectedToken(tt.name);
          this.tokens.copyExpectedToken(tt.name);
        }
      } else if (this.tokens.matches1(tt.braceL)) {
        this.tokens.copyToken();
        while (!this.tokens.matches1(tt.braceR)) {
          if (this.tokens.matches3(tt.name, tt.name, tt.comma) || this.tokens.matches3(tt.name, tt.name, tt.braceR)) {
            // type foo
            this.tokens.removeToken();
            this.tokens.removeToken();
            if (this.tokens.matches1(tt.comma)) {
              this.tokens.removeToken();
            }
          } else if (this.tokens.matches5(tt.name, tt.name, tt.name, tt.name, tt.comma) || this.tokens.matches5(tt.name, tt.name, tt.name, tt.name, tt.braceR)) {
            // type foo as bar
            this.tokens.removeToken();
            this.tokens.removeToken();
            this.tokens.removeToken();
            this.tokens.removeToken();
            if (this.tokens.matches1(tt.comma)) {
              this.tokens.removeToken();
            }
          } else if (this.tokens.matches2(tt.name, tt.comma) || this.tokens.matches2(tt.name, tt.braceR)) {
            // foo
            if (this.isTypeName(this.tokens.identifierName())) {
              this.tokens.removeToken();
              if (this.tokens.matches1(tt.comma)) {
                this.tokens.removeToken();
              }
            } else {
              foundNonTypeImport = true;
              this.tokens.copyToken();
              if (this.tokens.matches1(tt.comma)) {
                this.tokens.copyToken();
              }
            }
          } else if (this.tokens.matches4(tt.name, tt.name, tt.name, tt.comma) || this.tokens.matches4(tt.name, tt.name, tt.name, tt.braceR)) {
            // foo as bar
            if (this.isTypeName(this.tokens.identifierNameAtIndex(this.tokens.currentIndex() + 2))) {
              this.tokens.removeToken();
              this.tokens.removeToken();
              this.tokens.removeToken();
              if (this.tokens.matches1(tt.comma)) {
                this.tokens.removeToken();
              }
            } else {
              foundNonTypeImport = true;
              this.tokens.copyToken();
              this.tokens.copyToken();
              this.tokens.copyToken();
              if (this.tokens.matches1(tt.comma)) {
                this.tokens.copyToken();
              }
            }
          } else {
            throw new Error("Unexpected import form.");
          }
        }
        this.tokens.copyExpectedToken(tt.braceR);
      }
      return !foundNonTypeImport;
    }
  }, {
    key: "isTypeName",
    value: function isTypeName(name) {
      return this.isTypeScriptTransformEnabled && !this.nonTypeIdentifiers.has(name);
    }
  }, {
    key: "processExportDefault",
    value: function processExportDefault() {
      if (shouldElideDefaultExport(this.isTypeScriptTransformEnabled, this.tokens, this.declarationInfo)) {
        // If the exported value is just an identifier and should be elided by TypeScript
        // rules, then remove it entirely. It will always have the form `export default e`,
        // where `e` is an identifier.
        this.tokens.removeInitialToken();
        this.tokens.removeToken();
        this.tokens.removeToken();
        return true;
      }
      var alreadyHasName = this.tokens.matches4(tt._export, tt._default, tt._function, tt.name) ||
      // export default async function
      this.tokens.matches5(tt._export, tt._default, tt.name, tt._function, tt.name) && this.tokens.matchesContextualAtIndex(this.tokens.currentIndex() + 2, ContextualKeyword._async) || this.tokens.matches4(tt._export, tt._default, tt._class, tt.name) || this.tokens.matches5(tt._export, tt._default, tt._abstract, tt._class, tt.name);
      if (!alreadyHasName && this.reactHotLoaderTransformer) {
        // This is a plain "export default E" statement and we need to assign E to a variable.
        // Change "export default E" to "let _default; export default _default = E"
        var defaultVarName = this.nameManager.claimFreeName("_default");
        this.tokens.replaceToken("let ".concat(defaultVarName, "; export"));
        this.tokens.copyToken();
        this.tokens.appendCode(" ".concat(defaultVarName, " ="));
        this.reactHotLoaderTransformer.setExtractedDefaultExportName(defaultVarName);
        return true;
      }
      return false;
    }

    /**
     * In TypeScript, we need to remove named exports that were never declared or only declared as a
     * type.
     */
  }, {
    key: "processNamedExports",
    value: function processNamedExports() {
      if (!this.isTypeScriptTransformEnabled) {
        return false;
      }
      this.tokens.copyExpectedToken(tt._export);
      this.tokens.copyExpectedToken(tt.braceL);
      while (!this.tokens.matches1(tt.braceR)) {
        if (!this.tokens.matches1(tt.name)) {
          throw new Error("Expected identifier at the start of named export.");
        }
        if (this.shouldElideExportedName(this.tokens.identifierName())) {
          while (!this.tokens.matches1(tt.comma) && !this.tokens.matches1(tt.braceR) && !this.tokens.isAtEnd()) {
            this.tokens.removeToken();
          }
          if (this.tokens.matches1(tt.comma)) {
            this.tokens.removeToken();
          }
        } else {
          while (!this.tokens.matches1(tt.comma) && !this.tokens.matches1(tt.braceR) && !this.tokens.isAtEnd()) {
            this.tokens.copyToken();
          }
          if (this.tokens.matches1(tt.comma)) {
            this.tokens.copyToken();
          }
        }
      }
      this.tokens.copyExpectedToken(tt.braceR);
      return true;
    }

    /**
     * ESM elides all imports with the rule that we only elide if we see that it's
     * a type and never see it as a value. This is in contract to CJS, which
     * elides imports that are completely unknown.
     */
  }, {
    key: "shouldElideExportedName",
    value: function shouldElideExportedName(name) {
      return this.isTypeScriptTransformEnabled && this.declarationInfo.typeDeclarations.has(name) && !this.declarationInfo.valueDeclarations.has(name);
    }
  }]);
  return ESMImportTransformer;
}(Transformer);
export { ESMImportTransformer as default };